import __var_0__ from '@stdlib/assert/is-number';
import __var_1__ from '@stdlib/assert/is-positive-number';
import __var_2__ from '@stdlib/assert/is-nan';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isNumber = __var_0__.isPrimitive;
var isPositive = __var_1__.isPrimitive;
var isnan = __var_2__;


// MAIN //

/**
* Validates parameters.
*
* @private
* @param {number} x0 - location parameter
* @param {PositiveNumber} gamma - scale parameter
* @returns {(Error|null)} error or null
*
* @example
* var err = validate( 1.0, 2.5 );
* if ( err ) {
*     throw err;
* }
*/
function validate( x0, gamma ) {
	if ( !isNumber( x0 ) || isnan( x0 ) ) {
		return new TypeError( 'invalid argument. `x0` must be a number primitive and not `NaN`. Value: `' + x0 + '`.' );
	}
	if ( !isPositive( gamma ) ) {
		return new TypeError( 'invalid argument. `gamma` must be a positive number. Value: `' + gamma + '`.' );
	}
	return null;
}


// EXPORTS //
export default validate;
